export default __webpack_public_path__ + "static/media/1127.89430126.png";